import { auth0AuthProvider } from './auth0-auth-provider';
import { supabaseAuthProvider } from './supabase-auth-provider';
import { AuthProvider } from './types';

import { AuthProviderType } from '@/features/auth/types/enums/auth-provider-type';
import { StorageKeys, StorageService } from '@/services/storage.service';

const providers: Record<AuthProviderType, AuthProvider> = {
  [AuthProviderType.SUPABASE]: supabaseAuthProvider,
  [AuthProviderType.AUTH0]: auth0AuthProvider,
};

const isValidAuthProvider = (value: string | null): value is AuthProviderType => {
  return value === AuthProviderType.SUPABASE || value === AuthProviderType.AUTH0;
};

export const getStoredAuthProvider = (): AuthProviderType | null => {
  const storedValue = StorageService.getItem(StorageKeys.AUTH_PROVIDER);

  if (!isValidAuthProvider(storedValue)) {
    return null;
  }

  return storedValue;
};

export const setStoredAuthProvider = (provider: AuthProviderType | null) => {
  if (!provider) {
    StorageService.removeItem(StorageKeys.AUTH_PROVIDER);
    return;
  }

  StorageService.setItem(StorageKeys.AUTH_PROVIDER, provider);
};

export const getAuthProvider = (providerType: AuthProviderType) => {
  return providers[providerType];
};

export const getAccessTokenForProvider = async (providerType: AuthProviderType) => {
  return getAuthProvider(providerType).getAccessToken();
};
